<template>
  <div class="login_bg_1 blue_">
    <div class="top_header_">
      <img class="logo_" src="../assets/medilinkPC/logo.png" />
      <label class="com_">
        {{ $t("title") || "中间带(北京)技术服务有限公司" }}</label
      >
      <div class="lang_">
        <a-popover>
          <template slot="content">
            <p>中文</p>
            <p>English</p>
          </template>
          <span @click="changeLanguage">
            {{ $i18n.locale == "zh-cn" ? "中文" : "English" }}
          </span>
        </a-popover>
      </div>
    </div>
    <div class="login_container_1">
      <p style="text-align: center;font-size: 20px;">
        {{ $t("personalInfo[34]") || "重置密码" }}
      </p>
      <p style="color: #e60000; text-align: center">
        {{ $t("personalInfo[49]") || "若您是首次登录，则无法重置密码" }}
      </p>
      <p style="color: #e60000; margin-top: -10px; text-align: center">
        {{ $t("personalInfo[50]") || "请联系24小时在线客服寻求支持" }}
      </p>
      <p style="color: #e60000; margin-top: -10px; text-align: center">
        {{ $t("personalInfo[51]") || "24小时在线客服：(+86)400-880-8820" }}
      </p>
      <div class="login_right_">
        <a-input
          v-model="cardNo"
          style="width: 300px;height: 50px;margin-bottom: 19px;"
          :placeholder="$t('personalInfo[35]') || '请输入保险卡号'"
        ></a-input>
        <a-input
          v-model="idNo"
          style="width: 300px;height: 50px;margin-bottom: 19px;"
          :placeholder="$t('personalInfo[37]') || '请输入您的证件后六位'"
        ></a-input>
        <a-input
          v-model="newPwd"
          type="password"
          style="width: 300px;height: 50px;margin-bottom: 19px;"
          :placeholder="$t('personalInfo[52]') || '输入新密码（8-20位数字、字母组合）'"
        ></a-input>
        <a-input
          v-model="newPwdFornt"
          type="password"
          style="width: 300px;height: 50px;margin-bottom: 19px;"
          :placeholder="$t('personalInfo[53]') || '再次输入密码'"
        ></a-input>
        <a-row type="flex" justify="space-between">
          <a-col
            ><a-button
              type="primary"
              style="width: 130px;height: 40px;"
              @click="resetPwd"
              >{{ $t("personalInfo[38]") || "确认重置" }}</a-button
            ></a-col
          >
          <a-col
            ><a-button style="width: 130px;height: 40px;" @click="cancel">{{
              $t("InsuranceInfo[15]") || "取消"
            }}</a-button></a-col
          >
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import { setLogined, setLang } from "@/utils/authorized";
import moment from "moment";
import { setTimeout } from "timers";
import encrypt from '@/utils/crypt'
const checkMsg = {
  cardNo: {
    en: 'Please enter the insurance card number!',
    zh: '请输入保险卡号'
  },
  idNo: {
    en: 'Please enter the last six digits of your id!',
    zh: '请输入您的证件后六位'
  },
  newPwd: {
    en: 'Please enter Confirm password',
    zh: '请输入确认密码'
  },
  newPwdFornt: {
    en: 'Please enter Reenter password',
    zh: '请输入再次输入密码'
  },
}
export default {
  data() {
    return {
      errorMsg: "",
      hasError: false,
      mobileForm: this.$form.createForm(this),
      activeTab: 0,
      imgCodeUri: "/api/login/defaultKaptcha?rand=" + Math.random(),
      submitDisabled: false,

      loginType: "account", // account 账号  mobile 手机号
      flag: true,

      cardNo: "",
      idNo: "",
      newPwd: "", // 新密码
      newPwdFornt: "", // 确认新密码
    };
  },
  computed: {
    isEn() {
      return this.$i18n.locale == "en-us";
    }
  },
  mounted() {
    // let sideBar = document.getElementById('sideBar')
    // sideBar.style.display = 'none'
    this.cardNo = this.$route.query.cardNo;
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    cancel() {
      this.$router.push({
        name: "login"
      });
    },
    // 必填校验
    isEmpty(){
      let isReauired = ['cardNo', 'idNo', 'newPwd', 'newPwdFornt']
      let empty = isReauired.find(m => {
        return !(this[`${m}`] + '')
      })
      if (empty) {
        let msg = this.isEn ? checkMsg[`${empty}`].en : checkMsg[`${empty}`].zh
        this.$message.error(msg);
        return false;
      }
      return true
    },
    resetPwd() {
      let param = {
        cardNo: this.cardNo,
        idNo: this.idNo,
        newPwd: encrypt(this.newPwd)
      };
      let _result = this.isEmpty() // 为空校验
      if (!_result) {
        return
      }
      let reg = new RegExp(/^[a-zA-Z0-9]{8,20}$/);
      if (!reg.test(this.newPwd)){
        let msg = this.isEn ? 'A combination of 8-20 digits and letters, case sensitive!' : '8-20位数字、字母组合，区分大小写!'
        this.$message.error(msg);
        return;
      }

      if(this.newPwd !== this.newPwdFornt) {
        let msg = this.isEn ? 'Two password inconsistencies!' : '两次输入密码不一致！'
        this.$message.error(msg);
        return;
      }
      api
        .resetPwd(param)
        .then(res => res.data)
        .then(data => {
          if (data.code == "200") {
            this.$message.success(data.msg);
            setTimeout(() => {
              this.$router.push({
                name: "login"
              });
            }, 1000);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    forgetPwd() {
      this.$router.push("/Home/ForgetPwd");
    },
    rememberPwd(e) {
      console.log(`checked = ${e.target.checked}`);
    },
    changeLoginType() {
      if (this.loginType == "account") {
        this.flag = false;
        this.loginType = "mobile";
      } else {
        this.flag = true;
        this.loginType = "account";
      }
    },

    saveLang(langNum) {
      const lang = langNum == "01" ? "zh-cn" : "en-us";
      setLang(lang);
      moment.locale(lang);
      this.$i18n.locale = lang;
    },
    changeLanguage() {
      let lang = "zh-cn";
      let langNum = "01";
      if (this.isEn) {
        this.$i18n.locale = "zh-cn";
      } else {
        this.$i18n.locale = "en-us";
        lang = "en-us";
        langNum = "02";
      }
      setLang(lang);
      moment.locale(lang);
      api
        .changeLang({
          language: langNum
        })
        .then(res => res.data);
    }
  }
};
</script>
<style lang="scss">
.error_ {
  color: red;
  line-height: 24px;
  height: 24px;
  &.hide_ {
    visibility: hidden;
  }
  &.show_ {
    visibility: show;
  }
}
.login_bg_1 {
  height: 100%;
  overflow: hidden;
  // background: url("../assets/medilinkPC/home_bg.jpg") no-repeat;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 150px;
  .top_header_ {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.8);
    padding: 12px 44px 0 43px;
    height: 60px;
    // margin-bottom: 60px;
    .com_ {
      color: #333333;
      font-size: 15px;
      margin-left: 42px;
    }

    .logo_ {
      width: 102px;
      height: auto;
    }
    .lang_ {
      float: right;
      margin-right: 24px;
      cursor: pointer;
      position: relative;
      ::before {
        content: "";
        position: absolute;
        top: 8px;
        left: 120%;
        border: 4px solid;
        border-color: #394155 transparent transparent transparent;
      }
    }
  }
  .left_wrap_ {
    display: inline-block;
    vertical-align: middle;
    color: #fff;
    width: 373px;
    margin-right: 143px;
    .list_ {
      li {
        &::before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 8px;
          background: #fff;
          vertical-align: middle;
        }
      }
    }
    .line_ {
      width: 36px;
      height: 3px;
      background: rgba(255, 255, 255, 1);
    }
    .title_ {
      font-size: 26px;
      margin: 28px 0;
    }
    .copyright_ {
      margin: 29px 0 19px;
    }
    .fs9_ {
      font-size: 9px;
    }
  }
}
.login_container_1 {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 740px;
  // height: 480px;
  box-sizing: border-box;
  // background: url("../assets/medilinkPC/login_container.png");
  background-size: 100% 100%;
  * {
    box-sizing: border-box;
  }
  .login_left_ {
    position: absolute;
    top: 50%;
    left: 85px;
    width: 15px;
    color: #fff;
    line-height: 22px;
    font-size: 18px;
    transform: translateY(-50%);
  }
  .login_right_ {
    padding: 72px 100px 72px 100px;
    background-color: #fff;
    margin: 0 auto;
    width: 500px;
    height: 100%;
    .btn_ {
      display: flex;
      justify-content: space-between;
    }
    .login_type_ {
      text-align: right;
      margin-right: 30px;
      margin-top: 30px;
      font-size: 14px;
      color: #2c5acc;
    }
    .type_ {
      width: 300px;
      transform: translate(25%, 10%);
      .tit_ {
        font-size: 18px;
        color: #394155;
      }
      .img_ {
        width: 16px;
        height: 16px;
      }
      .forget_ {
        margin-top: -10px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        .forget_pwd {
          color: #2c5acc;
        }
      }
      .form_ {
        background-color: #fff;
      }
    }
    .mobile_type_ {
      transform: translateY(25%);
    }
    .bottom_logo_ {
      position: absolute;
      left: 35%;
      width: 101px;
      height: 32px;
      img {
        margin-top: 30px;
        width: 100%;
        height: 100%;
      }
    }
  }
  .login_title_ {
    margin-bottom: 29px;
    height: 27px;
    cursor: pointer;

    li {
      display: inline-block;
      color: #999999;
      font-size: 12px;
      transition: all 0.3s ease-in;
      margin-right: 29px;
      &.active_ {
        font-size: 18px;
        color: #333333;
        font-weight: 600;
      }
    }
  }
  .veri_code_ {
    width: 70px;
    height: 31px;
    background: rgba(239, 242, 255, 1);
    position: absolute;
    top: 50%;
    z-index: 2;
    transform: translateY(-50%);
    line-height: 0;
    right: 12px;
  }
  .steps_wrap_ {
    font-size: 9px;
    color: #666666;
    text-align: center;
    margin: 26px 0 42px;

    li {
      display: inline-block;
      vertical-align: middle;
    }
    .desc_01_ {
      width: 96px;
    }
    .desc_02_ {
      width: 66px;
    }
    .step_ {
      display: block;
      width: 16px;
      height: 16px;
      margin: 0 auto;
      border-radius: 50%;
      line-height: 16px;
      background: #23e2b7;
      color: #fff;
      text-align: center;
      margin-bottom: 7px;
    }
    .arrow_ {
      display: inline-block;
      vertical-align: middle;
      width: 40px;
      height: 21px;
      background: url("../assets/arrow.png") no-repeat;
      background-size: 100% auto;
      margin: 0 28px 0 23px;
    }
  }
}
.login_form_ {
  background-color: #fff;
}
.login_form_ .login-form-button {
  width: 100%;
  margin: 0 auto;
  background: linear-gradient(90deg, rgba(35, 226, 183, 1) 100%);
  border-radius: 3px;
  border: none;
  &:hover {
    background: linear-gradient(90deg, rgba(35, 226, 183, 0.6) 100%);
  }
  &:focus {
    background: linear-gradient(90deg, rgba(35, 226, 183, 1) 100%);
  }
}
</style>
